module.exports = __webpack_public_path__ + "static/media/wisepalTwitter-600x314.bb0baeba.jpg";